// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
  height: 100%;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.side-menu {
  flex: unset !important;
  display: flex !important;
  width: 300px !important;
  max-width: none !important;
}

.page-header {
  font-size: 24px;
  font-weight: 600;
  text-align: left;
  display: flex;
  justify-content: flex-start;
  margin-bottom: 50px;
}
.ant-layout-content {
  padding: 2%;
}

.app-header, .app-header-full {
  border-bottom: 1px solid #e9ecef;
  background-color: #ffffff !important;
  padding: 0px !important;
}
.signin-footer {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-weight: 200;
}

body {
  font-family: 'Inter' !important;
  min-height: 568px;
}
.app-header-full {
  height: 100px !important;
  line-height: 100px !important;
}
.header-right-container, .header-left-container {
  display: flex;
  flex-direction: row;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 300;
  font-size: 14px;
  line-height: 17px;
  text-align: right;
  letter-spacing: 0.03em;
  color: var(--background-white);
  align-items: center;
}
.header-right-container {
  text-align: right;
  margin-right: 30px;
  justify-content: space-between;
  gap: 10px;
}
.header-left-container {
  text-align: left;
  margin-left: 30px;
  gap: 11px;
}
.header2-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 60px;
  align-items: center;
}
.username-title {
  padding-left: 7px;
}
.language-title {
  padding-left: 9px;
}
.username-language-container {
  gap: 28px;
}
.language-icon {
  gap: 9px;
}
.app-footer {
  display: flex;
  flex-direction: column;
  align-self: center;
  margin-bottom: 25px;
}
.footer1, .footer2 {
  font-family: 'Inter';
  font-style: normal;
  font-size: 14px;
  line-height: 17px;
  text-transform: capitalize;
  text-align: left;
}
.footer1 {
  color: rgba(0, 0, 0, 0.88);
  font-weight: 200 !important;
  margin-bottom: 7px;
}
.footer2 {
  color: #001A11;
  font-weight: 400;
}
.app-signin-footer {
  border-top: 1px solid #e9ecef;
  background-color: var(--background-white) !important;
  /*  */
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
.wrapper-container {
  min-height: 40vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,6BAA6B;AAC/B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,QAAQ;AACV;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,oDAAoD;EACpD,KAAK;EACL,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB","sourcesContent":[".App {\n  text-align: center;\n  height: 100%;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.side-menu {\n  flex: unset !important;\n  display: flex !important;\n  width: 300px !important;\n  max-width: none !important;\n}\n\n.page-header {\n  font-size: 24px;\n  font-weight: 600;\n  text-align: left;\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 50px;\n}\n.ant-layout-content {\n  padding: 2%;\n}\n\n.app-header, .app-header-full {\n  border-bottom: 1px solid #e9ecef;\n  background-color: #ffffff !important;\n  padding: 0px !important;\n}\n.signin-footer {\n  display: flex;\n  justify-content: space-between;\n  font-size: 14px;\n  font-weight: 200;\n}\n\nbody {\n  font-family: 'Inter' !important;\n  min-height: 568px;\n}\n.app-header-full {\n  height: 100px !important;\n  line-height: 100px !important;\n}\n.header-right-container, .header-left-container {\n  display: flex;\n  flex-direction: row;\n  font-family: 'Inter';\n  font-style: normal;\n  font-weight: 300;\n  font-size: 14px;\n  line-height: 17px;\n  text-align: right;\n  letter-spacing: 0.03em;\n  color: var(--background-white);\n  align-items: center;\n}\n.header-right-container {\n  text-align: right;\n  margin-right: 30px;\n  justify-content: space-between;\n  gap: 10px;\n}\n.header-left-container {\n  text-align: left;\n  margin-left: 30px;\n  gap: 11px;\n}\n.header2-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  height: 60px;\n  align-items: center;\n}\n.username-title {\n  padding-left: 7px;\n}\n.language-title {\n  padding-left: 9px;\n}\n.username-language-container {\n  gap: 28px;\n}\n.language-icon {\n  gap: 9px;\n}\n.app-footer {\n  display: flex;\n  flex-direction: column;\n  align-self: center;\n  margin-bottom: 25px;\n}\n.footer1, .footer2 {\n  font-family: 'Inter';\n  font-style: normal;\n  font-size: 14px;\n  line-height: 17px;\n  text-transform: capitalize;\n  text-align: left;\n}\n.footer1 {\n  color: rgba(0, 0, 0, 0.88);\n  font-weight: 200 !important;\n  margin-bottom: 7px;\n}\n.footer2 {\n  color: #001A11;\n  font-weight: 400;\n}\n.app-signin-footer {\n  border-top: 1px solid #e9ecef;\n  background-color: var(--background-white) !important;\n  /*  */\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.wrapper-container {\n  min-height: 40vh;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
